import { FC } from 'react'

import styled from 'styled-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Loader } from '@mantine/core'

import { ClientItem } from 'src/Components/ClientItem'
import { Client } from 'src/Redux/api/clientsApi'
import { TableLoading } from 'src/Components/TableLoading'
import { NoDataMessage } from 'src/Components/NoDataMessage'
import { Pagination } from 'src/Helpers/types.ts'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  flex: 1;
  min-height: 0;
`

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 16px;
`

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const LoaderWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

type ClientsTableProps = {
  clients?: Client[]
  isLoading: boolean
  onArchiveClient: (id: number) => void
  onEditClient: (id: Client) => void
  isArchiveClientAvailable: boolean
} & Pagination

export const ClientsTable: FC<ClientsTableProps> = ({
  clients,
  isLoading,
  onArchiveClient,
  onEditClient,
  onLoadMore,
  hasNextPage,
  isArchiveClientAvailable,
}) => {
  if (isLoading) {
    return (
      <ListWrapper>
        <TableLoading />
      </ListWrapper>
    )
  }

  if (clients?.length === 0) {
    return (
      <ListWrapper>
        <NoDataMessage />
      </ListWrapper>
    )
  }
  return (
    <Container>
      <ListWrapper id='scrollableDiv'>
        <InfiniteScroll
          scrollableTarget={'scrollableDiv'}
          dataLength={clients?.length || 0}
          next={onLoadMore}
          hasMore={Boolean(hasNextPage)}
          loader={
            <LoaderWrapper>
              <Loader color='blue' />
            </LoaderWrapper>
          }
        >
          <ItemsContainer>
            {clients?.map((client) => (
              <ClientItem
                key={client.id}
                onArchiveItem={onArchiveClient}
                isArchiveClientAvailable={isArchiveClientAvailable}
                onEditItem={onEditClient}
                client={client}
              />
            ))}
          </ItemsContainer>
        </InfiniteScroll>
      </ListWrapper>
    </Container>
  )
}
